import $ from 'jquery'; 
window.$ = window.jQuery = $;
var dt = require('datatables.net');
import 'datatables.net-dt/css/jquery.datatables.css';


$(document).ready(function(){
         // DataTable
        $('#datatables-reponsive').DataTable({
             "displayLength": 25,
             processing: true,
             serverSide: true,
             ajax: "/getcountry",
             columns: [
                 { data: 'id' },
                 { data: 'name' },
                 { data: 'phonecode' },
                 { data: 'currency' },
             ]
         });
 });


//Workstream data table

$(document).ready(function()
{
    $('#workstream-datatable').DataTable(
    {
        "order": [ [ 6, 'desc' ]],
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/getworkstream",
        columns:[
                    { data: 'companyName' },
                    { data: 'categoryType' },
                    { data: 'id' },
                    { data: 'name' },
                    { data: 'Subject' },
                    { data: 'created_at' },
                    { data: 'updated_date' },
                    { data: 'view_more' },
                    { data: 'review' },
                ]      
    });
});



$(document).ready(function()
{
    $('#quotes-reponsive').DataTable(
    {
        "order": [ [ 5, 'desc' ]],
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/getquotes",
        columns:[
                    { data: 'quote_id' },
                    { data: 'Subject' },
                    { data: 'categoryType' },
                    { data: 'companyName' },
                    { data: 'finalprice' },
                    { data: 'date' },
                    { data: 'status' },
                    { data: 'view' },
                ]
    });
});

//schedule datatable
$(document).ready(function()
{
    $('#schedule-list').DataTable(
    {
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/admin/schedule/datatble",
        columns:[
                    { data: 'task_id' },
                    { data: 'title' },
                    { data: 'desc' },
                    { data: 'frequency' },
                    { data: 'cron_date' },
                    { data: 'frequency_data' },
                    { data: 'option' },
                ]
    });
});



//Invention data table

$(document).ready(function()
{
    $('#invention-datatable').DataTable(
    {
        "order": [ [ 4, 'desc' ]],
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/getinventions",
        columns:[
                    { data: 'invention_id' },
                    { data: 'title' },
                    { data: 'inventorCategoryName' },
                    { data: 'created_at' },
                    { data: 'updated_at' },
                    { data: 'menu' },
                    
                ]      
    });
});


//Project
$(document).ready(function()
{
    $('#project-datatable').DataTable({
             "displayLength": 25,
             processing: true,
             serverSide: true,
             ajax: "/getproject",
             columns: [
                 { data: 'project_id' },
                 { data: 'projectName' },
                 { data: 'projectDescription' },
                 { data: 'option' },
             ]
         });
});


//account datatable

/*$(document).ready(function()
{
    $('#acconttable').DataTable({
             "displayLength": 50,
             processing: true,
             serverSide: true,
             ajax: "/getaccount",
             columns: [
                 { data: 'stageName' },
                 { data: 'quoteSubject' },
                 { data: 'ProjectName' },
                 { data: 'quoteComapnyName' },
                 { data: 'payment' },
                 { data: 'finalprice' },
                 { data: 'bal' },
                 { data: 'budget' },
                 { data: 'view' },
                 { data: 'precord' },
             ]
         });
});
*/

//vendor data table

//vendor workstream
$(document).ready(function()
{
    $('#vendor-workstream-datatable').DataTable(
    {
        "order": [ [ 5, 'desc' ]],
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/getvendorworkstreamdata",
        columns:[
                    { data: 'id' },
                    { data: 'name' },
                    { data: 'Subject' },
                    { data: 'categoryType' },
                    { data: 'created_at' },
                    { data: 'updated_date' },
                    { data: 'view_more' },
                    { data: 'review' },
                ]     
    });
});

//vendor quotes
$(document).ready(function()
{
    $('#vendor-quote-datatable').DataTable(
    {
        "order": [ [ 5, 'desc' ]],
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/getvendorquotedata",
        columns:[
                    { data: 'quote_id' },
                    { data: 'Subject' },
                    { data: 'categoryType' },
                    { data: 'name' },
                    { data: 'finalprice' },
                    { data: 'updated_at' },
                    { data: 'view_more' },
                ]      
    });
});

//vendor ads
$(document).ready(function()
{
    $('#vendor-ads-datatable').DataTable(
    {
        "order": [ [ 2, 'desc' ]],
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/getvendoradsdata",
        columns:[
                    { data: 'categoryType' },
                    { data: 'created_at' },
                    { data: 'updated_date' },
                    { data: 'status' },
                    { data: 'view' },
                ]      
    });
});


//vendor rating review
$(document).ready(function()
{
    $('#vendor-rating-datatable').DataTable(
    {
        "order": [ [ 4, 'desc' ]],
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/getvendorratingdata",
        columns:[
                    { data: 'workstream_id' },
                    { data: 'comments' },
                    { data: 'stars' },
                    { data: 'created_at' },
                    { data: 'updated_date' },
                    { data: 'status' },
                    { data: 'view' },
                    { data: 'options' },
                ]      
    });
});


//admin data tables

$(document).ready(function()
{
    let cid = $('#cid').val();
    let url = '/getadminvendorlist' 
    if(cid != null || cid != ' ' || cid != undefined)
    {
         url = '/getadminvendorlist' +"?cid=" + cid;
    }
    $('#admin-vendor-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: url,
         columns: [
             { data: 'name' },
             { data: 'companyName' },
             { data: 'addressLine1' },
             { data: 'coname' },
             { data: 'sname' },
             { data: 'email' },
             { data: 'view' },
         ]
     });
});
//showcase category list

$(document).ready(function()
{
    $('#admin-showcategory-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminshowcategorylist",
         columns: [
             { data: 'inventorCategoryName' },
             { data: 'inventorCategoryDescription' },
             { data: 'view' },
         ]
     });
});

//vendor category

$(document).ready(function()
{
    $('#admin-vendor-category-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminvendorcategorylist",
         columns: [
             { data: 'categoryType' },
             { data: 'description' },
             { data: 'view' },
         ]
     });
});

//review

$(document).ready(function()
{
    let type = $('#type').val();
    let url = '/getadminratingreviewlist/' + type
    $('#admin-rating-review-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: url,
         columns:   [
                        { data: 'workstream_id' },
                        { data: 'comments' },
                        { data: 'stars' },
                        { data: 'created_at' },
                        { data: 'updated_at' },
                        { data: 'vendor_reason' },
                        { data: 'status' },
                        { data: 'view' },
                        { data: 'review' },
                    ]
     });
});

//showcase review

$(document).ready(function()
{
    let type = $('#type').val();
    let url = '/getadminshowcasereviewlist/' + type
    $('#admin-showcase-review-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: url,
         columns:   [
                        { data: 'invention_id' },
                        { data: 'title' },
                        { data: 'inventorCategoryName' },
                        { data: 'status' },
                        { data: 'adminapprovalcomment' },
                        { data: 'created_at' },
                        { data: 'updated_at' },
                        { data: 'view' },
                    ]
     });
});

//Vendor ads


$(document).ready(function()
{
    let type = $('#type').val();
    let url = '/getadminvendoradsreviewlist/' + type
    $('#admin-vedor-ads-review-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: url,
         columns:   [
                        { data: 'name' },
                        { data: 'companyName' },
                        { data: 'categoryType' },
                        { data: 'status' },
                        { data: 'adminapprovalcomment' },
                        { data: 'created_at' },
                        { data: 'updated_at' },
                        { data: 'view' },
                        { data: 'review' },
                    ]
     });
});

//vendor review

$(document).ready(function()
{
    let type = $('#type').val();
    let cid = $('#cid').val();
    let url = '/getadminvendorreviewlist/' + type;
    if(cid != null || cid != ' ')
    {
         url = '/getadminvendorreviewlist/' + type +"?cid=" + cid;
    }
    $('#admin-vendor-review-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: url,
         columns:   [
                        { data: 'name' },
                        { data: 'companyName' },
                        { data: 'coname' },
                        { data: 'sname' },
                        { data: 'user_email' },
                        { data: 'verified' },
                        { data: 'status' },
                        { data: 'view' },
                        { data: 'adminapprovalcomment' },
                        { data: 'review' },
                    ]
     });
});

$(document).ready(function()
{
    $('#admin-communication-list-datatable').DataTable(
    {
        "displayLength": 25,
        processing: true,
        serverSide: true,
        ajax: "/adminworkstreamlist",
        columns:[
                    { data: 'id' },
                    { data: 'name' },
                    { data: 'Subject' },
                    { data: 'created_at' },
                    { data: 'updated_date' },
                    { data: 'view_more' },
                ]      
    });
});


$(document).ready(function()
{
    $('#admin-inventor-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadmininventorlist",
         columns: [
             { data: 'name' },
             { data: 'addressLine1' },
             { data: 'coname' },
             { data: 'sname' },
             { data: 'city' },
             { data: 'email' },
             { data: 'view' },
         ]
     });
});

$(document).ready(function()
{
    $('#admin-blog-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminbloglist",
         columns: [
             { data: 'content_id' },
             { data: 'title' },
             { data: 'contentType' },
             { data: 'status' },
             { data: 'created_at' },
             { data: 'update_at' },
             { data: 'view' },
         ]
     });
});

$(document).ready(function()
{
    $('#admin-page-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminpagelist",
         columns: [
             { data: 'content_id' },
             { data: 'title' },
             { data: 'contentType' },
             { data: 'status' },
             { data: 'created_at' },
             { data: 'update_at' },
             { data: 'view' },
         ]
     });
});

//blog tag

$(document).ready(function()
{
    $('#admin-blog-tag-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminblogtaglist",
         columns: [
             { data: 'tag_id' },
             { data: 'tagName' },
             { data: 'created_at' },
             { data: 'updated_at' },
             { data: 'view' },
         ]
     });
});

//Review tag

$(document).ready(function()
{
    $('#admin-review-tag-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminreviewtaglist",
         columns: [
             { data: 'ratingTag_id' },
             { data: 'tagName' },
             { data: 'created_at' },
             { data: 'updated_at' },
             { data: 'view' },
         ]
     });
});


//newsletter

$(document).ready(function()
{
    $('#admin-new-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminnewslist",
         columns: [
             { data: 'email' },
             { data: 'created_at' },
             { data: 'updated_at' },
             { data: 'view' },
         ]
     });
});


$(document).ready(function()
{
    $('#admin-project-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminprojectlist",
         columns: [
             { data: 'stage_id' },
             { data: 'stageName' },
             { data: 'stageDescription' },
             { data: 'sequence' },
             { data: 'view' },
         ]
     });
});

$(document).ready(function()
{
    $('#admin-review-history-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminreviewhistorylist",
         columns: [
             { data: 'reviewHistory_id' },
             { data: 'url' },
             { data: 'userActionTimestamp' },
             { data: 'adminname' },
             { data: 'adminActionTimestamp' },
             { data: 'STATUS' },
             { data: 'time' },

         ]
     });
});



$(document).ready(function()
{
    $('#admin-intro-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminintrolist",
         columns: [
             { data: 'aliasName' },
             { data: 'admin_id' },
             { data: 'created_at' },
             { data: 'updated_date' },
             { data: 'view' },

         ]
     });
});

$(document).ready(function()
{
    $('#admin-seo-option-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getadminseoconfiglist",
         columns: [
             { data: 'seo_config_id' },
             { data: 'config_name' },
             { data: 'created_at' },
             { data: 'updated_at' },
             { data: 'view' },

         ]
     });
});

$(document).ready(function()
{
    $('#inventor-feasibility-list-datatable').DataTable({
         "displayLength": 25,
         processing: true,
         serverSide: true,
         ajax: "/getFeasibility/list",
         columns: [
             { data: 'study_no' },
             { data: 'title' },
             { data: 'created_at' },
             { data: 'updated_at' },
             { data: 'option' },

         ]
     });
});



$(document).on('change', '.vendorchange', function(e) 
{
    let x = document.getElementById("vendorSelect").value;
    let url = '/admin/vendor/review';
    window.location.href=url+"/"+x;
});

$(document).on('change', '.vendorfiltercategory', function(e) 
{
    let x = document.getElementById("categorySelect").value;
    let id = $('.vendorfiltercategory option:selected').data('id');
    let url = '/admin/vendor/review';
    window.location.href=url+"/"+id + "?cid=" + x;
});

$(document).on('change', '.vendorlistfiltercategory', function(e) 
{
    let x = document.getElementById("categorySelect").value;
    let url = '/vendor-list';
    window.location.href=url+"?cid=" + x;
});

